// Take one snapshot for all running entries so rows and summaries agree.
export const prepareTrackerReport = (data, now = Date.now()) => {
  const entries = (data["hydra:member"] || []).map((entry) => {
    const duration = entry.timeEnd
      ? Number(entry.duration ?? 0)
      : Math.floor((now - new Date(entry.timeStart).getTime()) / 1000);

    return {
      ...entry,
      duration: Number.isFinite(duration) ? Math.max(0, duration) : 0,
    };
  });
  const totalEntries = Number(data["hydra:totalItems"] ?? 0);
  const hasAllEntries = data["hydra:totalItems"] != null &&
    entries.length === totalEntries;

  // The API aggregate may omit running entries. Only replace it when the
  // complete filtered collection is available; a page is not a global total.
  // Never add running time to the API aggregate: it may already include it.
  const totalDuration = hasAllEntries
    ? entries.reduce((total, entry) => total + entry.duration, 0)
    : Number(data.totalDuration ?? 0);

  return { entries, totalEntries, totalDuration };
};
